<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NFSWro/tc-custom/9781459231535.jpg?1743822400923" alt="This image is the cover for the book Viscount's Bride"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Viscount's Bride
      </h1>
      <p class="bookDescription body article font2">
        <b>Lady Chloe Had Nowhere To Turn</b><br/><br/>Either she followed her guardian’s dictates and married a wholly detestable suitor or she settled for the comfortable love of a sensible man. Faced with a bleak future on either front, Chloe settled for Mr. Safe and Sensible. It wasn’t until her so-called “safe” choice tried to compromise her reputation that Brandt, Lord Salcombe, rushed in to save her. But how dare Brandt now insist that the next time she wanted a kiss she come to him! Chloe had no illusions about the viscount being ideal husband material. Still, his offer was temptingand certainly promised a future filled with passion!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ann Elizabeth Cree
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bfbf3a30